import { DisableReason, PaymentCategoryType, PaymentMethodStatus } from 'consts';
import delayUnmount from '../../../hoc/delayUnmount';
import { COMPONENT_BY_TYPE, IMAGE_BY_TYPE } from '../AppPayment.types';

const convertPaymentMethod = (paymentList: IPaymentMethod[]) =>
  paymentList.map(paymentMethod => {
    const { type } = paymentMethod;
    const sizeOfAvailableItems = paymentMethod.paymentMethods.filter(
      item => item.status === PaymentMethodStatus.ENABLED
    ).length;
    const isDisabled = sizeOfAvailableItems === 0;
    const defaultDisableReason =
      paymentList.length === 0
        ? DisableReason.METHOD_DISABLED
        : paymentMethod.paymentMethods.map(item => item.disableReason).filter(x => x !== undefined)[0];

    const imageType =
      paymentMethod.type === PaymentCategoryType.CARD && paymentMethod.paymentMethods.length > 1
        ? IMAGE_BY_TYPE.CLICK_TO_PAY
        : IMAGE_BY_TYPE[type];
    return {
      ...paymentMethod,
      component: delayUnmount(COMPONENT_BY_TYPE[type]),
      image: imageType,
      isChecked: false,
      isDefaultStyle: true,
      isDisabled,
      disableReason: isDisabled ? defaultDisableReason : undefined,
    };
  });

export default convertPaymentMethod;
